import { render, staticRenderFns } from "./DashboardLayout.vue?vue&type=template&id=5ad95376&scoped=true&"
import script from "./DashboardLayout.vue?vue&type=script&lang=ts&"
export * from "./DashboardLayout.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardLayout.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./DashboardLayout.vue?vue&type=style&index=1&id=5ad95376&scoped=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "5ad95376",
  null
  
)

export default component.exports